import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FaBars, FaTimes, FaSearch, FaUser, FaShoppingBag } from 'react-icons/fa';
import { auth } from '../../services/firebase';
import { signOut } from 'firebase/auth';
import Logo from '../../assets/logo.png';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [authOpen, setAuthOpen] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setCurrentUser(user);
        });
        return () => unsubscribe();
    }, []);

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            setAuthOpen(false);
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    const handleGoogleSignIn = async () => {
        try {
            const provider = new GoogleAuthProvider();
            await signInWithPopup(auth, provider);
            setAuthOpen(false);
        } catch (error) {
            console.error("Google sign in error:", error);
        }
    };

    return (
        <div className='navbar'>
            <div className='navbar-left'>
                <FaBars onClick={() => setMenuOpen(true)} className="icon clickable" />
                <span onClick={() => setMenuOpen(true)} className="menu-label">Menu</span>
                <FaSearch className="icon" />
                <span className="menu-label">Search</span>
            </div>
            
            <div className="navbar-center">
                <a href='/'><img className='brand' src={Logo} alt='Alex Menswear Logo' /></a>
            </div>

            <div className='navbar-right'>
                <a href='/contact'><span className="contact">Contact Us</span></a> 
                <FaUser 
                    className="icon clickable" 
                    onClick={() => setAuthOpen(true)} 
                />
                <div className="cart-wrapper">
                    <FaShoppingBag className="icon" />
                </div>
            </div>

            {/* Navbar Menu */}
            {menuOpen && (
                <div className='side-menu'>
                    <FaTimes onClick={() => setMenuOpen(false)} className="close-icon clickable" />
                    <ul>
                        <a href='/shop-all'><li>Shop All</li></a>
                        <a href='/new'><li>New</li></a>
                        <a href='/men'><li>Men</li></a>
                        <a href='/shirts'><li>Shirts</li></a>
                        <a href='/sale'><li>Sale</li></a>
                        <a href='/apex'><li>The Apex Collection FW/25</li></a>
                        <a href='/maison'><li>The Maison Alex Menswear</li></a>
                    </ul>
                    <div className="help">Can we help you? <br/> HELP@ALEXMENSWEAR.COM</div>
                </div>
            )}

            {/* Auth Modal - Shows different content based on auth state */}
            {authOpen && (
                <div className='auth-modal'>
                    <FaTimes onClick={() => setAuthOpen(false)} className="close-icon clickable" />
                    
                    {currentUser ? (
                        <>
                            <div className="user-info">
                                <p>Hello, <strong>{currentUser.displayName || currentUser.email.split('@')[0]}</strong></p>
                                <p>Signed in as: {currentUser.email}</p>
                            </div>
                            <div className="auth-actions">
                                <a href="/dashboard" className="account-link">
                                    Dashboard
                                </a>
                                <a href="/orders" className="account-link">
                                    My Orders
                                </a>
                                <a href="/wishlist" className="account-link">
                                    Wishlist
                                </a>
                                <a href="/track-my-order" className="account-link">
                                    Track Your Order
                                </a>
                                <a href="/rewards-center" className="account-link">
                                    Rewards Center
                                </a>
                                <button onClick={handleSignOut} className="signout-btn">
                                    Sign Out
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <h2>Welcome!</h2>
                            <p>Have an Alex Menswear account already? Sign In.</p>
                            <button 
                                className="google-btn"
                                onClick={handleGoogleSignIn}
                            >
                                Sign In With Google
                            </button>
                            <div className="divider">OR</div>
                            <div className="line"/>
                            <form className="auth-form">
                                <h2>Log In</h2>
                                <label>Email Address*</label>
                                <input type="text" placeholder=""/>
                                <label>Password*</label>
                                <input type="password" />
                                <a href="/forgot-password">Forgot your password?</a>
                                <button type="submit">Sign In</button>
                            </form>
                            <div className="line"/>
                            <div className="create-account">
                                <h2>Don't have an account?</h2>
                                <p>Access your Alex Menswear account to discover your wishlist and order history.</p>
                                <a href='/sign-up'><button>Create a Alex Menswear Account</button></a>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default Navbar;